export default __webpack_public_path__ + "static/media/admin_product_content_active.44142177.svg";